export default class SuperCurvePainter {
  constructor() {
  }

  rotate(cx,cy,angle,x,y)
  {
    if(angle === 0) return [x,y];
    let s = Math.sin(angle);
    let c = Math.cos(angle);

    x -= cx;
    y -= cy;

    let xnew = x * c - y * s;
    let ynew = x * s + y * c;

    return [xnew + cx, ynew + cy];
  }

  superformula(t, kx, ky, krx, kry, m1, m2, n1, n2, n3, a, b) {
    if(n1 === 0) return;
    if(a === 0) return;
    if(b === 0) return;
    let t1 = Math.cos(m1*t/4);
    let t2 = Math.sin(m2*t/4);
    let r0 = Math.pow(Math.abs(t1/a),n2) + Math.pow(Math.abs(t2/b),n3);
    let r = Math.pow(r0, -1/n1);
    return [kx + krx*r*Math.cos(t),ky + kry*r*Math.sin(t)];
  }

  drawCurve(context,shape,x,y,w,h,zoom,m1,m2,n1,n2,n3,a,b,rot,rx,ry) {
    let len = 4*Math.PI;
    let t=0;
    let k=0;
    let delta = 0.01;
    context.beginPath();
    while(t<len) {
      let p = this.superformula(t,x,y,rx,ry,m1,m2,n1,n2,n3,a,b);
      if(!p) continue;
      p = this.rotate(x,y,-rot,p[0],p[1]);
      let xc = (p[0]/(zoom/2))*w/2+w/2;
      let yc = (p[1]/(zoom/2))*h/2+h/2;
      if(k === 0) context.moveTo(xc,yc);
      else context.lineTo(xc,yc);
      k++;
      t+=delta;
    }
    context.closePath();
    context.strokeShape(shape);
  }

}
